import { LimitedTermDuration } from '@platform-frontend/checkout-drop-in';
import { LicenseValidityDuration } from '../model/license-validity-context';

export const isLimitedTermDuration = (duration: LicenseValidityDuration | null): duration is LimitedTermDuration => {
  return (
    duration !== null &&
    duration !== 'UNLIMITED' &&
    typeof duration === 'object' &&
    'runtime' in duration &&
    'unit' in duration &&
    typeof duration.runtime === 'number' &&
    typeof duration.unit === 'string'
  );
};
